
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Checkbox extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop() label?: string;
  @Prop() border?: string;

  private switchValue(): void {
    this.$emit("input", !this.value);
  }
}
